import axios from 'axios';
import AsyncLocalStorage from '@createnextapp/async-local-storage';
import { createBrowserHistory } from 'history';

// Toast notification helper
const showToast = (message, type = 'error') => {
  // Create toast container if it doesn't exist
  let toastContainer = document.getElementById('global-toast-container');
  if (!toastContainer) {
    toastContainer = document.createElement('div');
    toastContainer.id = 'global-toast-container';
    toastContainer.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      z-index: 9999;
    `;
    document.body.appendChild(toastContainer);
  }

  // Create toast element
  const toast = document.createElement('div');
  toast.style.cssText = `
    background: ${type === 'error' ? '#f44336' : '#4caf50'};
    color: white;
    padding: 16px 24px;
    border-radius: 4px;
    margin-bottom: 10px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.2);
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    animation: slideIn 0.3s ease-out;
    min-width: 300px;
  `;
  toast.textContent = message;

  // Add animation
  const style = document.createElement('style');
  style.textContent = `
    @keyframes slideIn {
      from {
        transform: translateX(400px);
        opacity: 0;
      }
      to {
        transform: translateX(0);
        opacity: 1;
      }
    }
  `;
  if (!document.getElementById('toast-animation-style')) {
    style.id = 'toast-animation-style';
    document.head.appendChild(style);
  }

  toastContainer.appendChild(toast);

  // Remove toast after 3 seconds
  setTimeout(() => {
    toast.style.animation = 'slideIn 0.3s ease-out reverse';
    setTimeout(() => {
      toast.remove();
    }, 300);
  }, 3000);
};
// import Auth from './Auth';

const METHOD = {
  GET: 'get',
  POST: 'post',
  PUT: 'put',
  DELETE: 'delete'
};

const history = createBrowserHistory();

// Module-level flag - shared across ALL Api instances
let isRedirecting = false;

// const BASEURL = process.env.REACT_APP_API_URL;
const BASEURL = "https://administrator.pocketpayy.com/api/"
// const BASEURL = 'http://192.168.1.131/pocketpay_backend/api/';

// const BASEURL = "https://pocketpay.org.in/administrator/api/";2`
// const BASEURL = 'http://192.168.1.18/tellzme_backend/api/';
// const BASEURL = "http://192.168.1.19/tellzme_backend/api/";

// const BASEURL = process.env.REACT_APP_API_URL;
// const BASEURL = "http://159.65.151.13/administrator/api/";
// const BASEURL = "http://localhost/globtalk_backend/api/";
// const BASEURL = "https://administrator.globtalk.in/api/";
// const BASEURL = "${api?.baseURL}";
// const BASEURL = 'http://192.168.29.246/pocketpay_backend/api/';
// const BASEURL = "https://dev.matchupmates.com:8091/api/";
// const BASEURL = "https://apis.matchupmates.com/api/";

// const BASEURL = 'http://192.168.1.16/tellzme_backend/api/';
// const BASEURL = "https://pocketpay.anques.in/administrator/api/";
// const BASEURL = "http://192.168.29.44/tellzme_backend/api/";
// const BASEURL = process.env.REACT_APP_API_URL;

// const BASEURL = "https://e2577xl97b.execute-api.sa-east-1.amazonaws.com/dev/";

class Api {
  isLoggedIn = false;

  constructor() {
    this.baseURL = BASEURL;
    this.isAlreadyFetchingAccessToken = true;
  }

  // URL FOR API
  // REFER SAMPLE JSON AT BOTTOM FOR DATA VALUES
  get(url, data) {
    return new Promise((resolve, reject) => {
      this.api(METHOD.GET, url, data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  post(url, data) {
    return new Promise((resolve, reject) => {
      this.api(METHOD.POST, url, data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  }

  put(url, data) {
    return new Promise((resolve, reject) => {
      this.api(METHOD.PUT, url, data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  }

  delete(url, data) {
    return new Promise((resolve, reject) => {
      this.api(METHOD.DELETE, url, data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  }

  api(method, url, data) {
    // this.getAuthenticationInfo();
    return AsyncLocalStorage.getItem('authToken').then(token => {
      if (token && token !== '') {
        this.isLoggedIn = true;
        this.accessToken = token;
      }
      return new Promise((resolve, reject) => {
        let axiosConfig = {};
        axiosConfig.method = method;

        axiosConfig.url = this.baseURL + url;

        axiosConfig.headers = this.setHeaders(data);
        if (data) {
          if (data.params) axiosConfig.params = data.params;

          if (data.data) axiosConfig.data = data.data;
        }

        axios(axiosConfig)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            // Handle 401 Unauthorized - clear storage and redirect to login
            if (error.response && error.response.status === 401) {
              // Use module-level flag - shared across ALL Api instances
              if (!isRedirecting) {
                isRedirecting = true;

                // Show toast message
                showToast('Your session has expired. Please login again.', 'error');

                // Clear all authentication data from localStorage
                localStorage.clear();
                AsyncLocalStorage.clear();

                // Wait 2 seconds before redirecting to login page
                setTimeout(() => {
                  isRedirecting = false; // Reset flag after redirect
                  window.location.href = '/auth/login';
                }, 2000);
              }

              reject({ success: false, message: 'Session expired' });
              return;
            }

            // Handle other errors
            if (error.response) {
              reject(error.response.data);
            } else {
              reject(error);
            }
          });
      });
    });
  }

  setHeaders(data) {
    let headers = {};
    headers['accept-language'] = 'en';
    headers['Content-Type'] = 'application/json';
    headers['Xapi'] = 'jwZryAdcrffggf867DnjhjhfRvsfhjs08032022';

    if (data) {
      if (data.isMultipart) {
        headers['Content-Type'] = 'multipart/form-data';
      }

      if (data.headers) {
        for (var key in data.headers) {
          if (data.headers.hasOwnProperty(key)) {
            headers[key] = data.headers[key];
          }
        }
      }
    }

    if (this.isLoggedIn !== false && !(data && data.skipAuth)) {
      headers['Authorization'] = 'Bearer ' + this.accessToken;
      // headers['Authorization'] = this.accessToken;
      // headers['x-access-token'] = this.accessToken;
    }

    return headers;
  }
}

// SAMPLE DATA JSON
/* let sample_data = {

    // ADDITIONAL HEADERS IF REQUIRED
    headers :{
        'Content-type'  : 'xx-urlencode',
    },

    // IF USER ID AND TOKEN SHOULDN'T BE PASSED IN HEADERS (USER FOR AFTER LOGIN API)
    // DEFAULT : FALSE;
    skipAuth    : false,

    // IF Default error handling needs to be overridden
    // DEFAULT : FALSE;
    skipErrorHandling    : false,

    // FOR SENDING FILES OR FORM DATA REQUEST
    isMultipart : true,

    // `PARAMS` ARE THE URL PARAMETERS TO BE SENT WITH THE REQUEST
    params : {
        user_id     : 10,
        name        : "lorem",
        page        : 3,
        sort_by     : 'name'
    },

    // POST DATA
    data : {
        firstName   : 'Lorem',
        lastName    : 'Ipsum'
    },
} */

export default Api;
